import React, { ComponentType, ErrorInfo, FunctionComponent } from 'react';
import { getLogger } from '../../common/logger/logger';

type State = {
  error?: Error;
  errorInfo?: React.ErrorInfo;
};

function withErrorBoundary<Props>(
  WrappedComponent: ComponentType<Props> | FunctionComponent<Props>,
  onError: (e: Error, ei?: ErrorInfo) => JSX.Element,
  loggerName?: string,
): ComponentType<Props> {
  // eslint-disable-next-line react/display-name
  return class extends React.Component<Props, State> {
    log = getLogger(loggerName ?? 'ErrorBoundary');

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
      this.setState({ error, errorInfo }, () => {
        this.log.error('caught error in boundary', { error, errorInfo });
      });
    }

    render(): JSX.Element {
      if (this.state?.error) {
        return onError(this.state.error, this.state?.errorInfo);
      }

      return <WrappedComponent {...this.props} />;
    }
  };
}

export default withErrorBoundary;
